/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
  output
} from '@angular/core';
import { MFileUploadState } from './m-file-upload.component.types';

import { MFileUploadService } from './m-file-upload.service';
import { ProgressBar } from 'primeng/progressbar';
import { Tooltip } from 'primeng/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-file-upload',
  templateUrl: './m-file-upload.component.html',
  styleUrls: ['./m-file-upload.component.scss'],
  imports: [ProgressBar, Tooltip]
})
export class MFileUploadComponent {
  private readonly mFileUploadService = inject(MFileUploadService);

  mFileUploadState = MFileUploadState;

  @Input()
  selectedFile: File = new File([], '');

  @Input()
  uploadButtonText = 'save';

  @Input()
  fileType = 'CSV';

  @Input()
  uploadState: MFileUploadState = MFileUploadState.idle;

  styleClass = 'success';

  @Input()
  customStyle = '';

  progress = 0;

  readonly fileSelected = output<File | null>();
  readonly progressUpdate = output<number>();

  errorMessage = '';

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    this.handleFile();
  }

  private handleFile() {
    if (
      this.selectedFile?.type.toLowerCase() !==
      `text/${this.fileType.toLowerCase()}`
    ) {
      this.uploadState = MFileUploadState.error;
      this.errorMessage = `Your file must be in the ${this.fileType} format.`;
      this.styleClass = 'error';
      this.progress = 100;
    } else {
      if (this.selectedFile) {
        this.readFile(this.selectedFile);
      }
      this.fileSelected.emit(this.selectedFile);
    }
  }

  updateProgress(progress: number) {
    this.mFileUploadService.updateProgress(progress);
  }

  readFile(file: File) {
    const reader = new FileReader();
    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        this.progress = Math.round((event.loaded / event.total) * 100);
        this.updateProgress(this.progress);
      }
    };

    reader.onloadend = () => {
      this.progress = 100;
      this.updateProgress(this.progress);
    };

    reader.readAsArrayBuffer(file);
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.selectedFile = event.dataTransfer?.files[0] as File;
    this.handleFile();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }
}
